import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GamePhase } from '../../../interfaces/game-state.interface';
import { GameModeService } from '../../../_services/game-mode.service';
import { MiniGameService } from '../../../_services/mini-game.service';
import { GlobalService } from 'src/app/_services/global.service';

/**
 * "Fun Games" picker — currently shows Bowling + a "more coming soon"
 * placeholder tile. Reached from `GAME_CATEGORY` when the player
 * picks the Fun Games tile.
 */
@Component({
  selector: 'app-fun-games-picker',
  templateUrl: './fun-games-picker.component.html',
  styleUrls: ['./fun-games-picker.component.scss']
})
export class FunGamesPickerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currLang: any = 'en';

  constructor(
    private gameModeService: GameModeService,
    private miniGameService: MiniGameService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  pickBowling(): void {
    this.miniGameService.goToBowlingSetup();
  }

  goBack(): void {
    this.gameModeService.setPhase(GamePhase.GAME_CATEGORY);
  }
}
